const dayMs = 86_400_000;

function utcCalendarDay(value: Date): number {
  return Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate());
}

export interface LicenseExpirationWarning {
  kind: 'EXPIRING' | 'EXPIRED';
  daysRemaining: number;
  message: string;
}

export function getLicenseExpirationWarning(
  expiresAt: string | null | undefined,
  now = new Date(),
): LicenseExpirationWarning | null {
  if (!expiresAt) return null;
  const expiration = new Date(expiresAt);
  if (Number.isNaN(expiration.getTime())) return null;

  const daysRemaining = Math.round((utcCalendarDay(expiration) - utcCalendarDay(now)) / dayMs);
  if (daysRemaining > 7) return null;
  if (daysRemaining < 0) {
    const formatted = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(expiration);
    return {
      kind: 'EXPIRED',
      daysRemaining,
      message: `Sua licença venceu em ${formatted}.`,
    };
  }
  if (daysRemaining === 0) {
    return { kind: 'EXPIRING', daysRemaining, message: 'Sua licença vence hoje.' };
  }
  return {
    kind: 'EXPIRING',
    daysRemaining,
    message: `Sua licença vence em ${daysRemaining} ${daysRemaining === 1 ? 'dia' : 'dias'}.`,
  };
}
